import { inject, Inject, Injectable } from '@angular/core';
import { Name } from '../enums/name.enum';
import { ISPUtil } from '../../shared/utils/isp.util';
import { AppConfig } from '../config/app-config.model';
import { AppConfigService } from '../config/app-config.service';

// const environment = {
//   "env": "dev",
//   "enableDebug": true,
//   "siteKey": "6Ldc6tUiAAAAABDHRDlMiqKxs3qm6dkhIH9_LIAM",
//   "apiBaseUrl": "https://d-console.thelightbulb.ai/isp_qual_api/",
//   "secretKey": "73229731d7d042999b43fa6dc8228097",
//   "zoomAuthUrl": "https://zoom.us/oauth/authorize",
//   "googleAuthUrl": "https://accounts.google.com/o/oauth2/auth",
//   "teamsAuthUrl": "https://login.microsoftonline.com/",
//   "showProcessingTypeDropdownToLightbulbOnly": false,
//   "showInsightCube": true
// };

@Injectable({
  providedIn: 'root',
})
export class TokenService {

  private readonly configi = inject(AppConfigService);
  private readonly secretKey = this.configi.secretKey;

  getExpiration(name: Name.AUTH_TOKEN | 'MEDIA_TOKEN') {
    var date = new Date();
    if (name === Name.AUTH_TOKEN) {
      date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000); // 365 days
    }
    // for media tokens
    date.setTime(date.getTime() + 180 * 60 * 1000); // 180 min for media token
    return date.toISOString();
  }

  public set(
    name: 'MEDIA_TOKEN',
    value: string,
    mediaTokenType: null | string = null
  ) {
    const keyName = mediaTokenType
      ? name + `_${mediaTokenType.toUpperCase()}`
      : name;
    // delete previous one
    this.delete(keyName);
    const encryptedVal = this.securityOperation('encrypt', value);

    sessionStorage.setItem(keyName, encryptedVal);
    sessionStorage.setItem(keyName + '_EXPIRATION', this.getExpiration(name));
  }

  public get(
    name: 'MEDIA_TOKEN',
    mediaTokenType: null | string = null
  ) {
    const keyName = mediaTokenType
      ? name + `_${mediaTokenType.toUpperCase()}`
      : name;

    if (this.isTokenExpired(keyName)) {
      return null;
    }

    const val = sessionStorage.getItem(keyName);
    if (!val) return null;
    return this.securityOperation('decrypt', val);
  }

  public delete(name: string) {
    sessionStorage.removeItem(name);
    sessionStorage.removeItem(name + '_EXPIRATION');
  }

  securityOperation(_case: 'encrypt' | 'decrypt', _text: any) {
    var secretKey = this.secretKey;
    if (_case == 'encrypt') {
      return ISPUtil.encrypt(secretKey, _text);
    } else {
      return ISPUtil.decrypt(secretKey, _text);
    }
  }

  isTokenExpired(keyName: string) {
    const val = sessionStorage.getItem(keyName + '_EXPIRATION');
    if (!val) return false;
    const expiry = new Date(val);
    const now = new Date();
    return now > expiry;
  }
}
